export default __webpack_public_path__ + "assets/940a9f4e6ca0fb9fe3dca6f7517a2e5a.png";